// Sdílené utility pro formátování položek nabídky.
// Modul je napsán v CommonJS, aby mohl být použit:
//   - v Node.js (backend/pdf/index.js – generování PDF)
//   - ve frontendu přes Parcel (offer-editor.js, offer-items.js, public-offer.js)
// Parcel CommonJS importy podporuje out-of-the-box.
//
// Proč existuje: jediné místo, kde se popisuje mapování kódů (formData) na
// lidský text ("Lakování: 1/0 UV lak parciální", …). Dříve byla stejná mapa
// kopírovaná ve 3 souborech, což způsobovalo rozchod editoru, veřejné nabídky
// a PDF.

const OFFER_FOOTER_DISCLAIMER =
  'Platnost nabídky je 60 dní od data vystavení. Tento dokument představuje nezávaznou cenovou nabídku a není návrhem na uzavření smlouvy dle § 1731 občanského zákoníku. K uzavření smlouvy dochází až potvrzením objednávky dodavatelem. Nabídka je určena výhradně uvedenému příjemci.';

const DIGITAL_COLOR = {
  lak_10_50: '1/0 lak (parciální)',
  lak_11_50: '1/1 lak (parciální)',
  lak_10_100: '1/0 lak (celá plocha)',
  lak_11_100: '1/1 lak (celá plocha)',
  bila_10_50: '1/0 bílá (parciální)',
  bila_11_50: '1/1 bílá (parciální)',
  bila_10_100: '1/0 bílá (celá plocha)',
  bila_11_100: '1/1 bílá (celá plocha)',
  zlata_10_50: '1/0 zlatá (parciální)',
  zlata_11_50: '1/1 zlatá (parciální)',
  zlata_10_100: '1/0 zlatá (celá plocha)',
  zlata_11_100: '1/1 zlatá (celá plocha)'
};

const LAK = {
  parcial10: '1/0 UV lak parciální',
  parcial11: '1/1 UV lak parciální',
  plocha10: '1/0 UV lak celá plocha',
  plocha11: '1/1 UV lak celá plocha',
  stroj10: '1/0 Stroj lak',
  stroj11: '1/1 Stroj lak'
};

const LAMINACE = {
  lesk10: '1/0 Lamino lesklé',
  lesk11: '1/1 Lamino lesklé',
  mat10: '1/0 Lamino matné',
  mat11: '1/1 Lamino matné',
  struktura10: '1/0 Lamino nepoškrabatelné',
  struktura11: '1/1 Lamino nepoškrabatelné',
  samet10: '1/0 Lamino sametové',
  samet11: '1/1 Lamino sametové',
  kapsaA5: '1/1 Laminace kapsová (A5)',
  kapsaA4: '1/1 Laminace kapsová (A4)',
  kapsaA3: '1/1 Laminace kapsová (A3)'
};

const FALCOVANI = {
  'half-fold': 'Na polovinu (1 lom)',
  'cross-fold': 'Křížový lom (2 lomy)',
  'u-fold': 'Do U (2 lomy)',
  'z-fold': 'Do Z (2 lomy)',
  'double-half-fold': 'Na polovinu (2 lomy)',
  'roll-fold': 'Harmonikové s přebalem (3 lomy)',
  'harmonium-fold-3': 'Harmonikové skládání (3 lomy)',
  'harmonium-fold-4': 'Harmonikové skládání (4 lomy)',
  'harmonium-fold-5': 'Harmonikové skládání (5 lomů)',
  'gate-fold': 'Skládání do psaníčka (3 lomy)',
  'double-gate-fold': 'Zavřené psaníčko (3 lomy)'
};

const BIGOVANI = {
  'half-fold': 'Na polovinu (1 big)',
  'cross-fold': 'Do kříže (2 bigy)',
  'u-fold': 'Do U (2 bigy)',
  'z-fold': 'Do Z (2 bigy)',
  'double-half-fold': 'Na polovinu (2 bigy)',
  'roll-fold': 'Harmonikové (3 bigy)',
  'harmonium-fold-3': 'Harmonikové (3 bigy)',
  'harmonium-fold-4': 'Harmonikové (4 bigy)',
  'harmonium-fold-5': 'Harmonikové (5 bigy)',
  'gate-fold': 'Skládání do psaníčka (3 bigy)',
  'double-gate-fold': 'Zavřené psaníčko (3 bigy)'
};

const VYSEK = {
  vlastni: 'Vlastní/půjčené výsekové železo',
  nove: 'Nové výsekové železo'
};

const PREDSEK = {
  1: 'Vlastní/půjčené předsekové železo',
  2: 'Nové předsekové železo'
};

const RAZBA = {
  1: 'Vlastní/půjčený štoček',
  2: 'Nový štoček'
};

const VRTANI = {
  '1dira2mm': '1 díra (2 mm)',
  '1dira4mm': '1 díra (4 mm)',
  '1dira5mm': '1 díra (5,5 mm)',
  '2diry2mm': '2 díry (2 mm)',
  '2diry4mm': '2 díry (4 mm)',
  '2diry5mm': '2 díry (5,5 mm)',
  'euro2diry2mm': 'Euro blok, 2 díry (2 mm)',
  'euro2diry4mm': 'Euro blok, 2 díry (4 mm)',
  'euro2diry5mm': 'Euro blok, 2 díry (5,5 mm)',
  '3diry2mm': '3 díry (2 mm)',
  '3diry4mm': '3 díry (4 mm)',
  '3diry5mm': '3 díry (5,5 mm)',
  'euro4diry2mm': 'Euro blok, 4 díry (2 mm)',
  'euro4diry4mm': 'Euro blok, 4 díry (4 mm)',
  'euro4diry5mm': 'Euro blok, 4 díry (5,5 mm)'
};

const LEPENI = {
  1: 'Lepení krabiček'
};

const VAZBA = {
  'V1-strojni': 'V1 (2 skoby) strojní',
  'V1-rucni': 'V1 (2 skoby) ručně',
  blok: 'Lepený blok',
  blokPrebal: 'Lepený blok s přebalem',
  'V2-PUR': 'V2 lepená (PUR)',
  V3: 'V3 lepená a šitá',
  V6: 'V6 leporelo',
  'krouzek-blok': 'Kroužková twin wire',
  'krouzek-kalendar': 'Kroužková s háčkem na pověšení',
  V4: 'V4 šitá, měkká obálka',
  V5: 'V5 šitá, tvrdá obálka',
  V2V8: 'V2V8 – falešná V8',
  V8: 'V8 šitá, tvrdá obálka'
};

const VAZBA_NA = {
  vysku: 'Na delší straně',
  sirku: 'Na kratší straně'
};

const BARVA_SPIRALY = {
  bila: 'Bílá',
  cerna: 'Černá',
  stribrna: 'Stříbrná',
  zlata: 'Zlatá'
};

function jeKrouzkova(typ) {
  return typeof typ === 'string' && typ.startsWith('krouzek');
}

function jeBlokova(typ) {
  return typ === 'blok' || typ === 'blokPrebal';
}

function jednotkaPocetStran(typ) {
  return jeBlokova(typ) || jeKrouzkova(typ) ? 'listů' : 'stran';
}

function vnitrniTiskLabel(typ, value) {
  if (jeBlokova(typ) || jeKrouzkova(typ)) {
    return value === 'stejna'
      ? 'Každý list stejný (opakující se motiv)'
      : 'Každý list jiný (kalendář, blok)';
  }
  return value === 'stejna'
    ? 'Každá strana stejná (blok, sešit)'
    : 'Každá strana jiná (brožura, katalog)';
}

function isTruthy(v) {
  return v === true || v === 'true' || v === 'on';
}

function buildMotivyLines(fd) {
  const lines = [];
  const motivy = Array.isArray(fd.motivy)
    ? fd.motivy.filter((m) => +(m.pocetKusu || 0) > 0)
    : [];

  if (motivy.length > 1) {
    const celkem = motivy.reduce((a, m) => a + (+m.pocetKusu || 0), 0);
    lines.push(`Motivy (${motivy.length}, celkem ${celkem} ks):`);
    motivy.forEach((m, i) => {
      const nazev = (m.nazev || '').trim() || `Motiv ${i + 1}`;
      lines.push(`· ${nazev}: ${(+m.pocetKusu || 0).toLocaleString('cs-CZ')} ks`);
    });
  } else if (+(fd.pocetDruhu || 1) > 1) {
    lines.push(`${fd.pocetDruhu} druhy (motivy)`);
  }

  return lines;
}

function buildVazbaLines(fd) {
  const lines = [];
  if (!nonZero(fd.vazba) || !VAZBA[fd.vazba]) return lines;

  const typ = fd.vazba;
  lines.push(`Vazba: ${VAZBA[typ]}`);

  if (nonZero(fd.vazbaPocetStran)) {
    lines.push(`Rozsah: ${fd.vazbaPocetStran} ${jednotkaPocetStran(typ)}`);
  }
  if (fd.vazbaNa && VAZBA_NA[fd.vazbaNa]) {
    lines.push(`Umístění vazby: ${VAZBA_NA[fd.vazbaNa]}`);
  }
  if (jeKrouzkova(typ) && fd.vazbaBarvaSpiraly && BARVA_SPIRALY[fd.vazbaBarvaSpiraly]) {
    lines.push(`Barva spirály: ${BARVA_SPIRALY[fd.vazbaBarvaSpiraly]}`);
  }
  if (fd.vazbaVnitrniTisk) {
    lines.push(`Tisk vnitřního bloku: ${vnitrniTiskLabel(typ, fd.vazbaVnitrniTisk)}`);
  }
  if (isTruthy(fd.vazbaJinaObalka)) {
    const casti = ['Jiná obálka než vnitřní blok'];
    if (fd.materialName) casti.push(`obálka: ${fd.materialName}`);
    if (fd.vnitrniMaterialName) casti.push(`vnitřek: ${fd.vnitrniMaterialName}`);
    lines.push(casti.join(' · '));
  }
  if (jeKrouzkova(typ) && fd.vazbaObalkaZada === 'ne') {
    lines.push('Obálka: jen přední list (záda šedá lepenka)');
  }
  if (+(fd.pocetDruhu || 1) > 1 && fd.vazbaMotivRozsah) {
    lines.push(fd.vazbaMotivRozsah === 'obalka-vnitrek'
      ? 'Motivy se liší: obálka i vnitřní blok'
      : 'Motivy se liší: jen obálka / přebal');
  }
  if (isTruthy(fd.vazbaPodlozka)) {
    lines.push('Šedá lepenka (podložka pod blok)');
  }

  return lines;
}

function nonZero(v) {
  return v !== undefined && v !== null && v !== '' && v !== '0' && v !== 0;
}

/**
 * Sestaví pole textových řádků popisujících dokončovací operace z formData.
 * Každý prvek = jedna operace (např. "Lakování: 1/0 UV lak parciální").
 * Pořadí odpovídá pořadí v editoru a ve zbytku aplikace.
 *
 * @param {object} formData
 * @returns {string[]}
 */
function buildFinishingLines(formData) {
  const fd = formData || {};
  const lines = [];

  lines.push(...buildMotivyLines(fd));
  lines.push(...buildVazbaLines(fd));

  if (nonZero(fd.barvyDigital) && DIGITAL_COLOR[fd.barvyDigital]) {
    lines.push(`Digitální speciální barva: ${DIGITAL_COLOR[fd.barvyDigital]}`);
  }
  if (nonZero(fd.lakovani) && LAK[fd.lakovani]) {
    lines.push(`Lakování: ${LAK[fd.lakovani]}`);
  }
  if (nonZero(fd.laminace) && LAMINACE[fd.laminace]) {
    lines.push(`Laminace: ${LAMINACE[fd.laminace]}`);
  }
  if (nonZero(fd.falcovani) && FALCOVANI[fd.falcovani]) {
    lines.push(`Falcování: ${FALCOVANI[fd.falcovani]}`);
  }
  if (nonZero(fd.bigovani) && BIGOVANI[fd.bigovani]) {
    lines.push(`Bigování: ${BIGOVANI[fd.bigovani]}`);
  }
  if (nonZero(fd.vysek) && VYSEK[fd.vysek]) {
    lines.push(`Výsek: ${VYSEK[fd.vysek]} (${fd.pozicNaVysek || '1'} pozic)`);
  }
  if (nonZero(fd.predsek) && PREDSEK[fd.predsek]) {
    lines.push(`Předsek: ${PREDSEK[fd.predsek]} (${fd.pozicNaPredsek || '1'} pozic)`);
  }
  if (nonZero(fd.razba) && RAZBA[fd.razba]) {
    lines.push(`Ražba: ${RAZBA[fd.razba]} (${fd.pozicNaRazbu || '1'} pozic)`);
  }
  if (nonZero(fd.vrtani) && VRTANI[fd.vrtani]) {
    lines.push(`Vrtání: ${VRTANI[fd.vrtani]}`);
  }
  if (nonZero(fd.perforace)) {
    const pocet = parseInt(fd.perforace, 10);
    if (pocet > 0) lines.push(`Perforace ${pocet}x`);
  }
  if (nonZero(fd.lepeni) && LEPENI[fd.lepeni]) {
    lines.push(LEPENI[fd.lepeni]);
  }

  return lines;
}

// Regex prefixy, které detekují "segment dokončovací operace" v dříve uloženém
// dlouhém názvu položky. Když stará nabídka má name = "100ks, A3, 4/0, Lakování:…,
// Laminace:…, Matná křída 200 g/m²", tyto prefixy ze jména vyhodíme, aby zůstala
// pouze kratší varianta dle nové konvence.
const FINISHING_NAME_PATTERNS = [
  /^Lakování:/i,
  /^Laminace:/i,
  /^Falcování:/i,
  /^Bigování:/i,
  /^Výsek:/i,
  /^Předsek:/i,
  /^Ražba:/i,
  /^Vrtání:/i,
  /^Perforace\s/i,
  /^Lepení krabiček$/i,
  /^Digitální speciální barva:/i,
  /^V\d/,
  /^Lepený blok/i,
  /^Kroužková/i,
  /^V2V8/i
];

/**
 * Odstraní z uloženého názvu položky segmenty, které popisují dokončovací
 * operace. Používá se při vykreslování starších nabídek, kde byl název uložen
 * se všemi operacemi spojený čárkou. Nové nabídky tento problém nemají –
 * `generateItemName()` už operace neskládá.
 *
 * Formát: segmenty oddělené ", ". Případný prefix "název zakázky: " se zachová.
 *
 * @param {string} name
 * @returns {string}
 */
function stripFinishingFromName(name) {
  if (!name) return '';
  const colonIdx = name.indexOf(': ');
  // Pokud je před dvojtečkou nějaký user-zadaný název zakázky (bez čárky), oddělíme ho.
  let prefix = '';
  let rest = name;
  if (colonIdx !== -1 && !name.slice(0, colonIdx).includes(',')) {
    prefix = name.slice(0, colonIdx + 2);
    rest = name.slice(colonIdx + 2);
  }

  const parts = rest.split(/,\s*/);
  const kept = parts.filter((segment) => {
    const trimmed = segment.trim();
    if (!trimmed) return false;
    return !FINISHING_NAME_PATTERNS.some((re) => re.test(trimmed));
  });

  return prefix + kept.join(', ');
}

module.exports = {
  buildFinishingLines,
  stripFinishingFromName,
  OFFER_FOOTER_DISCLAIMER,
  // exporty map – kdyby je frontend potřeboval přímo
  DIGITAL_COLOR,
  LAK,
  LAMINACE,
  FALCOVANI,
  BIGOVANI,
  VYSEK,
  PREDSEK,
  RAZBA,
  VRTANI,
  LEPENI,
  VAZBA
};
